export const deleteFirstLetter = (str: string) => (str ? str.substring(1) : str);
